'use client';

import Link from 'next/link';
import { AppRoute } from '../../../../../enums/enums';
import { usePathname } from 'next/navigation';
import { Tooltip } from '../../../../tooltip/tooltip';

const ROUTES_TO_BE_HIGHLIGHTED = [
  AppRoute.HEALING_NAVIGATOR,
  AppRoute.RESOURCES_SUPPORT,
];

const ReferToApligraphBlock = () => {
  const pathname = usePathname();

  if (!ROUTES_TO_BE_HIGHLIGHTED.find((route) => pathname.includes(route))) {
    return null;
  }

  return (
    <div className="text-[16px] text-wcw-footer-text">
      <p>
        Please refer to the{' '}
        <Tooltip content="Apligraf Package Insert (PDF, opens in a new tab)">
          <Link
            className="underline decoration-skip-ink-auto hover:no-underline"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.apligraf.com/pdf/Apligraf-Package-Insert.pdf"
            aria-label="Apligraf Package Insert (PDF, opens in a new tab)"
          >
            Apligraf Package Insert
            <span className="sr-only"> (PDF, opens in a new tab)</span>
          </Link>
        </Tooltip>{' '}
        for complete prescribing information.
      </p>
      <p>
        Please refer to the{' '}
        <Tooltip content="Apligraf Handling and Storage Instructions (PDF, opens in a new tab)">
          <Link
            className="underline decoration-skip-ink-auto hover:no-underline"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.apligraf.com/pdf/Apligraf-Storage-Handling-Guide.pdf"
            aria-label="Apligraf Handling and Storage Instructions (PDF, opens in a new tab)"
          >
            Apligraf Handling and Storage Instructions
            <span className="sr-only"> (PDF, opens in a new tab)</span>
          </Link>
        </Tooltip>{' '}
        prior to use.
      </p>
    </div>
  );
};

export { ReferToApligraphBlock };
